import { useParams } from 'react-router-dom';
import { Box, Container, Grid, Paper, ThemeProvider, Toolbar, Typography, useMediaQuery } from '@mui/material';
import PublicReportsService from '../shared-services/public-reports.service';
import { useEffect, useState } from 'react';
import gaiaTheme from '../../../root-components/theme';
import gaiaLogo from '../../../assets/corporate-logos/gaia/gaia-logo.png'
import { IGaiaReportWebpageReport } from '../shared-services/public-reports.model';
import { GaiaReportWebPage } from '../components/gaia-report-web-page';

export const PublicReportPage = () => {

  const { reportType, id } = useParams();
  const publicReportsService = new PublicReportsService()
  const [report, setReport] = useState<IGaiaReportWebpageReport>()
  const [error, setError] = useState<boolean>(false)
  const [errorCode, setErrorCode] = useState<number>()
  const isMobileMode = useMediaQuery(gaiaTheme.breakpoints.down('sm'));


  useEffect(() => {
    if (id && reportType) {
      publicReportsService.get(reportType, id)
        .then(response => {
          setReport(response)
        })
        .catch(err => {
          setError(true)
          if (err.response.data.code === 1) {
            setErrorCode(1)
          } else {
            setErrorCode(2)
          }
          console.log(err)
        })
    }
  }, [id, reportType])

  return (
    <>
      {reportType && (reportType === 'carbon-summary-report' || reportType === 'gaia') && report &&
          <GaiaReportWebPage report={report} />
      }
      <ThemeProvider theme={gaiaTheme}>
        {error && errorCode === 1 &&
          <Box style={{ backgroundColor: '#F0F1F3', minHeight: '100vh' }}>
            <Toolbar />
            <Container maxWidth="sm" sx={{ mt: 4, mb: 4 }}>
              <Grid container spacing={2}>
                <Grid item xs={12} md={12} lg={12}>
                  <img
                    src={gaiaLogo}
                    alt="GAIA logo"
                    height="70"
                    style={{ verticalAlign: 'middle', paddingLeft: '45px', paddingBottom: '15px' }}
                  />
                  <Paper variant='outlined'
                    sx={{
                      p: 2,
                      display: 'flex',
                      flexDirection: 'column',
                      height: 'auto'
                    }}
                  >
                    <Box sx={{ width: '90%', p: '24px' }}>
                      <Grid container spacing={2}>
                        <Grid item xs={12} md={12} lg={12}>
                          <Typography variant="h5">
                            Error
                          </Typography>
                        </Grid>
                        <Box
                          component="form"
                          noValidate
                          autoComplete="off"
                          sx={{
                            width: '100%',
                            ml: isMobileMode ? 0 : 2
                          }}
                        >
                          <Typography sx={{ pt: 2 }}>This webpage is no longer available. The link has been disabled.</Typography>
                        </Box>
                      </Grid>
                    </Box>
                  </Paper>
                </Grid>
              </Grid>
            </Container>
          </Box>
        }
        {error && errorCode === 2 &&
          <Box style={{ backgroundColor: '#F0F1F3', minHeight: '100vh' }}>
            <Toolbar />
            <Container maxWidth="sm" sx={{ mt: 4, mb: 4 }}>
              <Grid container spacing={2}>
                <Grid item xs={12} md={12} lg={12}>
                  <img
                    src={gaiaLogo}
                    alt="GAIA logo"
                    height="70"
                    style={{ verticalAlign: 'middle', paddingLeft: '45px', paddingBottom: '15px' }}
                  />
                  <Paper variant='outlined'
                    sx={{
                      p: 2,
                      display: 'flex',
                      flexDirection: 'column',
                      height: 'auto'
                    }}
                  >
                    <Box sx={{ width: '90%', p: '24px' }}>
                      <Grid container spacing={2}>
                        <Grid item xs={12} md={12} lg={12}>
                          <Typography variant="h5">
                            Error
                          </Typography>
                        </Grid>
                        <Box
                          component="form"
                          noValidate
                          autoComplete="off"
                          sx={{
                            width: '100%',
                            ml: isMobileMode ? 0 : 2
                          }}
                        >
                          <Typography sx={{ pt: 2 }}>There has been an error loading this webpage, please try again.</Typography>
                        </Box>
                      </Grid>
                    </Box>
                  </Paper>
                </Grid>
              </Grid>
            </Container>
          </Box>
        }
      </ThemeProvider>
    </>
  )
}



